<template>
  <div>
    <div v-show="visible" :style="{left:left+'px',top:top+'px'}" class="menu" ref="panelPlatform">
      <div style="margin-left: 0">
        <el-tooltip effect="dark" content="拖动" placement="top-start">
          <span class="drag-handle" @mousedown="mouseDownHandle($event)"
                @mouseup="mouseUpHandle($event)"><i
                  class="el-icon-rank"></i></span>
        </el-tooltip>
        <span class="title">{{ currentRow.nickname }}/{{ currentRow.platform_name }}-收入分类</span>
        <div class="check-all">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
                       class="checkbox-color">全选
          </el-checkbox>
        </div>

        <el-checkbox-group v-model="selectedOptions" @change="handleCheckedChange">
          <ul>
            <li v-for="(val,label) in options" :key="val">
              <el-checkbox :label="label" class="checkbox-color">
                {{ val }}
              </el-checkbox>
            </li>
          </ul>
        </el-checkbox-group>
        <div style="text-align: center;width: 100%;margin-top: 10px">
          <el-button type="primary" size="mini" @click="saveoptions">保存</el-button>
          <el-button size="mini" @click="closeMenu">关闭</el-button>
        </div>
        <!--        <div style="margin-top: 20px">-->
        <!--          <span style="margin-inline-start: 5px;">PS：从有账号的平台中选择要考核平台</span>-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PerformanceComponentsPerformanceSetting",
  props: {
    performanceType: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      moveDataelse: {
        x: null,
        y: null
      },
      //start:鼠标右键菜单
      visible: false,
      top: 0,
      left: 0,
      //end:鼠标右键菜单
      currentRow: {},
      currentColumn: {},
      options: [],//红人所有平台
      allOptions: [],//红人所有平台
      selectedOptions: [],//要显示的平台
      checkAll: true,
      isIndeterminate: false
    }
  },
  created() {

  },
  methods: {
    async init( top, left, currentRow ) {
      this.currentRow = currentRow
      this.top = top - 10
      this.left = left
      this.visible = true
      const {selected, options} = await this.$api.getPerformanceSetting({
        artist_id: currentRow.artist_id,
        platform_code: currentRow.platform_code,
        type: this.performanceType
      })
      this.selectedOptions = selected
      this.options = options
      if (this.options) {
        for (const key in this.options) {
          this.allOptions.push(key)
        }
      }

      this.isIndeterminate = this.selectedOptions.length > 0 && this.selectedOptions.length < this.allOptions.length;
      this.checkAll = this.selectedOptions.length === this.allOptions.length

    },
    async saveoptions() {
      //saveoptions
      const info = await this.$api.setPerformanceSetting({
        selected_options: this.selectedOptions,
        artist_id: this.currentRow.artist_id,
        platform_code: this.currentRow.platform_code,
        type: this.performanceType
      })
      if (info === 'ok') {
        // this.$notify.success('保存成功')
        this.closeMenu()
        this.$emit('savedEvent')
      }
    },
    handleCheckAllChange( val ) {
      this.selectedOptions = val ? this.allOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange( value ) {
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.allOptions.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allOptions.length;
    },
    closeMenu() {
      this.visible = false;
    },
    mouseDownHandle( event ) {
      this.$nextTick(() => {
        this.moveDataelse.x = event.pageX - this.$refs.panelPlatform.offsetLeft
        this.moveDataelse.y = event.pageY - this.$refs.panelPlatform.offsetTop
        event.currentTarget.style.cursor = 'move'
        window.onmousemove = this.mouseMoveHandle
      })

    },
    mouseMoveHandle( event ) {
      this.$nextTick(() => {
        const moveLeft = event.pageX - this.moveDataelse.x + 'px'
        const moveTop = event.pageY - this.moveDataelse.y + 'px'
        this.$refs.panelPlatform.style.left = moveLeft
        this.$refs.panelPlatform.style.top = moveTop
      })

    },
    mouseUpHandle( event ) {
      window.onmousemove = null
      event.currentTarget.style.cursor = 'move'
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  //background-color: rgba(255, 255, 255, 0.7);
  background-color: rgba(48, 49, 52, 0.7);
  border: solid 1px #f2f2f2;
  margin: 0;
  //background: #fff;
  z-index: 99999;
  position: absolute;
  list-style-type: none;
  padding: 15px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  //color: #333;
  color: #f2f2f2 !important;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em !important;
    margin-block-end: 1em !important;
    margin-inline-start: 10px;
    margin-inline-end: 10px;
    padding-inline-start: 10px;
    padding-inline-end: 10px;
    border-top: solid 1px #f2f2f2;
  }

  li {
    margin: 5px 0 2px 0;
    padding: 7px 10px;
    cursor: pointer;

    &:hover {
      background: rgba(255, 49, 118, 0.7);
      //background: rgba(48, 49, 52, 0.7);
    }
  }

  .title {
    font-size: 16px;
    text-align: center;
    font-weight: 700;
    padding-inline-start: 12px;
    padding-inline-end: 10px;
    margin-bottom: 20px;
    margin-inline-start: 1px;
    margin-inline-end: 10px;
  }

}

.checkbox-color {
  color: #f2f2f2;
}

.check-all {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em !important;
  margin-block-end: 1em !important;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  padding-inline-start: 10px;
  padding-inline-end: 10px;
  border-top: solid 1px #f2f2f2;
  margin: 5px 0 2px 0;
  padding: 7px 30px;
  cursor: pointer;

}
</style>
